import React, { useEffect, useState } from 'react';
import { getVesselRequirements } from '../../../../config/vesselRequirements';

const RequirementsDebug = ({ vesselConfig }) => {
  const [requirements, setRequirements] = useState(null);
  const [csvRequirements, setCsvRequirements] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    
    // Get requirements based on vessel config (hardcoded logic)
    const reqs = getVesselRequirements(vesselConfig);
    setRequirements(reqs);
    
    // CSV requirements no longer used - keeping for potential future reference
    setCsvRequirements(null);
    
    setLoading(false);
  }, [vesselConfig.operatingStatus, vesselConfig.waterCategory, vesselConfig.category]);

  if (loading) {
    return <div className="p-4">Loading requirements...</div>;
  }

  return (
    <div className="p-4 space-y-4">
      <div className="bg-blue-50 p-4 rounded">
        <h3 className="font-semibold text-blue-900">Vessel Configuration</h3>
        <p className="text-sm text-blue-700">
          Operating Status: {vesselConfig.operatingStatus || 'Not set'}<br />
          {vesselConfig.operatingStatus === 'seagoing' && (
            <>WBC3 Category: {vesselConfig.category || 'Not set'}</>
          )}
          {vesselConfig.operatingStatus === 'inland' && (
            <>Water Category: {vesselConfig.waterCategory || 'Not set'}</>
          )}
        </p>
      </div>

      <div className="bg-green-50 p-4 rounded">
        <h3 className="font-semibold text-green-900">
          Requirements Database: {vesselConfig.operatingStatus === 'inland' ? 'Inland Waterways' : 'WBC3 (Seagoing)'}
        </h3>
        <p className="text-sm text-green-700">
          Total CSV Requirements Found: {csvRequirements?.length || 0}
        </p>
      </div>

      {csvRequirements && csvRequirements.length > 0 && (
        <div className="bg-white border rounded p-4">
          <h4 className="font-semibold mb-2">Sample Requirements (First 10)</h4>
          <div className="space-y-2">
            {csvRequirements.slice(0, 10).map((req, index) => (
              <div key={index} className="text-sm border-b pb-2">
                <div className="font-medium">{req.name}</div>
                <div className="text-gray-600">
                  Category: {req.category} | Module: {req.module} | Reference: {req.reference}
                </div>
                {req.notes && (
                  <div className="text-gray-500 italic">{req.notes}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="bg-yellow-50 p-4 rounded">
        <h4 className="font-semibold text-yellow-900">Requirements by Category</h4>
        <div className="text-sm text-yellow-700 space-y-1">
          {Object.entries(requirements || {}).map(([category, items]) => (
            <div key={category}>
              {category}: {Array.isArray(items) ? items.length : 0} items
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RequirementsDebug;